/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import { SearchIcon } from "@dotnet/telematics-design-system";

import { ClearInputIcon } from "../../../../../../../InputField/components/ClearInputIcon";
import InputField from "../../../../../../../InputField/InputField";
import { useStyles } from "../../../../../../styles";

interface ISearchCompanyProps {
  isDisabled: boolean;
  isRootSearch: boolean;
  searchValue: string;
  handleSearchValue: (e: {
    target: {
      value: SetStateAction<string>;
    };
  }) => void;
  clearSearchValue: () => void;
}

const SearchCompany = ({
  isDisabled,
  isRootSearch,
  searchValue,
  handleSearchValue,
  clearSearchValue
}: ISearchCompanyProps) => {
  const { t } = useTranslation();

  const { searchCompanyDiv } = useStyles();

  const translationString = isRootSearch ? "child company" : "company name";

  return (
    <div css={css(searchCompanyDiv)}>
      <InputField
        autoFocus
        fullWidth
        size="medium"
        placeholder={t(`Search##search ${translationString}`)}
        iconLeft={<SearchIcon />}
        value={searchValue}
        onChange={handleSearchValue}
        iconRight={
          <ClearInputIcon value={searchValue} clearValue={clearSearchValue} />
        }
        disabled={isDisabled}
      />
    </div>
  );
};

export default SearchCompany;
